import FallbackHelper from '../../AAFPlayer/helpers/FallbackHelper';
import NewRelic from '../../../src/utils/trackers/NewRelic';
import logger from 'src/utils/logger/logger';

var FallbackUtil = (function() {
  var idFallbackTimeout = null;
  var callbackFallback = null;
  let outputParamsTemp = null;
  let error = null;
  var setCallbackFallback = function(callback) {
    callbackFallback = callback;
  };

  const getOutputParams = () => {
    return outputParamsTemp;
  }

  const setError = (err) => {
    error = err;
  }

  const getError = () => {
    return error;
  }

  const setPropertiesTimerFB = (outputParams) =>{
    return {
      isLive: outputParams.isLive,
      streamType: outputParams.streamType,
    };
  }

  var setFallbackTimeout = function(outputParams) {
    if(outputParams){
      outputParamsTemp = {...outputParams};
    }
    const fallbackIntervalTime = FallbackHelper.getFallbackIntervalTime(setPropertiesTimerFB(outputParams));
    clearFallback();
    NewRelic.actionText(`${'LogType: Newrelic File: FallbackUtil.js.js'} ${'Method: setFallbackTimeout'} ${'Segundos FallBack: ' + (fallbackIntervalTime/1000)} ${'Stream_type: ' + outputParams.streamType}`);
    logger.debug('Fallback interval time en segundos: ',(fallbackIntervalTime/1000), ', StreamType: ', (outputParams.streamType ? outputParams.streamType : 'N/A' ) );
    idFallbackTimeout = setTimeout(callbackFallback, fallbackIntervalTime, outputParams);
  };

  var clearFallback = function() {
    logger.debug('Se limpia fallback');
    if (idFallbackTimeout) {
      clearTimeout(idFallbackTimeout);
    }
    outputParamsTemp = null;
    idFallbackTimeout = null;
  };

  return {
    setCallbackFallback,
    setFallbackTimeout,
    clearFallback,
    setError,
    getError,
    getOutputParams
  };
})();

export default FallbackUtil;



// WEBPACK FOOTER //
// ./src/components/Video/FallbackUtil.js